export default function PHP_simplexml_load_string() {
  return (
    <div>
      <h1>PHP_simplexml_load_string</h1>
    </div>
  );
}
